export const env: { [key: string]: { studio: string, platform: string, latestVersion: string, latestVersionDownload:string } } = {
  development: {
    studio: "https://dev.studio.blings.io/",
    platform: "https://dev.studio.blings.io/",
    latestVersion: "https://dev.api.blings.io/v2/public/extension/latest",
    latestVersionDownload: "https://dev.api.blings.io/v2/public/extension/latest/download"
  },
  production: {
    studio: "https://studio.blings.io/",
    platform: "https://platform.blings.io/",
    latestVersion: "https://api.blings.io/v2/public/extension/latest",
    latestVersionDownload: "https://api.blings.io/v2/public/extension/latest/download"
  },
  staging: {
    studio: "https://staging.studio.blings.io/",
    platform: "https://staging.platform.blings.io/",
    latestVersion: "https://58hoje6tse.execute-api.eu-west-1.amazonaws.com/master/extension/latest",
    latestVersionDownload: "https://58hoje6tse.execute-api.eu-west-1.amazonaws.com/master/extension/latest/download"
  }
};